<template>
    <div class="card" id="print-car-specs">
        <header class="card-header">
            <p class="card-header-title">Specifications:</p>
            <a href="#" class="card-header-icon" aria-label="more options">
                  <span class="icon">
                    <i class="fas fa-cogs"></i>
                  </span>
            </a>
        </header>
        <div class="">
            <div class="content">
                <table class="table">
                    <tbody>
                    <tr>
                        <th>Brand:</th>
                        <td>{{ lot.manuf_name }}</td>
                    </tr>
                    <tr>
                        <th>Model:</th>
                        <td>{{ lot.model_name }}</td>
                    </tr>
                    <tr>
                        <th>Year:</th>
                        <td>{{ lot.year }}</td>
                    </tr>
                    <tr>
                        <th>Grade:</th>
                        <td><span v-html="lot.grade"></span></td>
                    </tr>
                    <tr>
                        <th>km's:</th>
                        <td>{{ lot.mileage }}</td>
                    </tr>
                    <tr>
                        <th>Chassis:</th>
                        <td><strong><a href="https://jpcenter.ru/month?lang=en" target="_blank" class="has-text-danger tooltip" data-tooltip="Manufacture check">{{ lot.body }} <i class="fas fa-search"></i></a></strong></td>
                    </tr>
                    <tr>
                        <th>Color:</th>
                        <td>{{ lot.colour }}</td>
                    </tr>
                    <tr>
                        <th>Transmission</th>
                        <td>{{ lot.transmission }}</td>
                    </tr>
                    <tr>
                        <th>Displacement:</th>
                        <td></td>
                    </tr>
                    <tr>
                        <th>Equipment:</th>
                        <td>{{ lot.equipment }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import '../../../node_modules/bulma-extensions/bulma-tooltip/dist/css/bulma-tooltip.min.css';
    export default {
       props:['lot']
    }
</script>

<style scoped>
    table {
        font-size: small;
    }
</style>



// WEBPACK FOOTER //
// src/components/StockCars/CarSpecsStock.vue